import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { fDateTimeWithTimezone } from "../../../../../utils/formatTime";

OrderLogApproval.propTypes = {
  logItem: PropTypes.object,
}

export default function OrderLogApproval({ logItem }) {
  return <Box>
    <Typography variant="body" color="info.main" sx={{wordBreak: 'break-word', whiteSpace: 'normal'}}>
      Order approved {logItem.approvedBy ? `by ${logItem.approvedBy}` : ''}
    </Typography>
    <Typography variant="body2" color="black">
      {fDateTimeWithTimezone(logItem.dateAdded)}
    </Typography>
  </Box>
}